//
//
//
//
//
//
//
//

export default {
  computed: {
    nullImg: function() {
      if (this.$root.themeType == "yellow") {
        return require("../assets/theme_yellow/null.png");
      } else {
        return require("../assets/theme_black/null.png");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/NoData.vue